import { useQuery } from 'react-query'

import { getShopExchange } from 'src/services/get/getShopExchange'
import getUserMaterialItems from 'src/services/get/getUserMaterialItems'

const useItemExchangeList = (enabled) => {
  return useQuery({
    queryFn: () => getShopExchange(),
    queryKey: 'shop-exchange-list',
    enabled: enabled
  })
}

const useMaterialList = (enabled) => {
  return useQuery({
    queryFn: () => getUserMaterialItems(),
    queryKey: 'get-material-list',
    enabled: enabled,
    staleTime: 0
  })
}

export { useItemExchangeList, useMaterialList }
